<template>
  <div class="container brew-content">
    <div class="row" style="margin-top: 20px">
        <h1>{{content.title}}</h1>
    </div>
    <div class="row" v-html="content.content"></div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ContentPage',
  title: '',
  pageClass: 'home-page',
  computed: {
    ...mapState('contents', ['content'])
  },
  methods: {
    ...mapActions('contents', ['getContentByURL'])
  },
  created () {
    this.getContentByURL(this.$route.params.url)
  }
}
</script>

<style scoped>

</style>
